import React, { useState } from 'react'
import { MdOutlineCancel } from 'react-icons/md'
import { useStateContext } from '../contexts/ContextProvider';
import ChangePassword from '../pages/User/ChangePassword';

const UserProfile = () => {
  const { handleClick, setToken } = useStateContext();
  const [showChangePassword, setShowChangePassword] = useState(false);

  const closeShowChangePassword = () => {
    setShowChangePassword(false);
  }
  const logout = () => {
    handleClick('');
    localStorage.removeItem('ACCESS_TOKEN');
    setToken(null);
  }
  return (
    <div
      onMouseLeave={() => handleClick('')}
      className="w-48 flex flex-col absolute top-12 right-6 rounded-xl bg-white shadow-lg ring-1 ring-gray-100 overflow-hidden transition-all duration-200"
    >
      <div className="flex justify-end p-2">
        <button
          type="button"
          onClick={() => handleClick('')}
          style={{ color: 'rgb(153,171,180)' }}
          className="p-1.5 rounded-full hover:bg-gray-100 transition-colors duration-150"
        >
          <MdOutlineCancel className="text-lg" />
        </button>
      </div>
      <div
        className="flex mx-2 mb-1.5 px-3 py-2 rounded-lg hover:bg-blue-50 text-sm cursor-pointer transition-colors duration-150"
        onClick={() => setShowChangePassword(true)}
      >
        <span className="text-gray-700 font-medium">Mot de passe</span>
      </div>
      <div
        className="flex mx-2 mb-1.5 px-3 py-2 rounded-lg hover:bg-blue-50 text-sm cursor-pointer transition-colors duration-150"
        onClick={logout}
      >
        <span className="text-gray-700 font-medium">Déconnexion</span>
      </div>
      {showChangePassword ? <ChangePassword onClose={closeShowChangePassword} /> : null}
    </div>
  )
}

export default UserProfile